'use client';

import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useSubmitMealRating } from '@/features/meal-rating/hooks/useSubmitMealRating';

import { StarRatingPicker } from './star-rating-picker';

interface MealRatingPromptProps {
  mealId: string;
  orderSlotId: string;
  onSubmitted?: () => void;
}

export function MealRatingPrompt({ mealId, orderSlotId, onSubmitted }: MealRatingPromptProps) {
  const t = useTranslations('mealRating');
  const [rating, setRating] = useState(0);
  const mutation = useSubmitMealRating({ onSubmitted });

  return (
    <div
      data-testid="meal-rating-prompt"
      className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="text-sm font-medium">{t('prompt')}</p>
      <div className="flex flex-col gap-2 sm:items-end">
        <div className="self-start sm:self-auto">
          <StarRatingPicker value={rating} onChange={setRating} disabled={mutation.isPending} />
        </div>
        <Button
          type="button"
          size="sm"
          disabled={rating === 0 || mutation.isPending}
          onClick={() => mutation.mutate({ mealId, orderSlotId, rating })}
        >
          {mutation.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
          <span>{t('submitButton')}</span>
        </Button>
      </div>
    </div>
  );
}
